import { render, staticRenderFns } from "./PythonPackages.vue?vue&type=template&id=7c153c4c&scoped=true"
import script from "./PythonPackages.vue?vue&type=script&lang=js"
export * from "./PythonPackages.vue?vue&type=script&lang=js"
import style0 from "./PythonPackages.vue?vue&type=style&index=0&id=7c153c4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c153c4c",
  null
  
)

export default component.exports